// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"2eaeda31","533":"8b18a20c"}[chunkId] + ".chunk.css";
};